<mat-tab-group>
  <mat-tab label="Dashboard">
    <div style="height: 100%;">
      <div style="width: 100%; background-color: rgba(243, 246, 248, 0.495); padding-bottom: 3px; border: 2px black;" class="row">
        <div class="col-md-4" style="padding: 4px;">
          <mat-label class="device-label">Select Device</mat-label>
          <mat-select class="device-select" [(ngModel)]="selectedDevice" (selectionChange)="onDeviceSelect($event.value)">
            <mat-option *ngFor="let dev of generatorIds" [value]="dev">
              {{ dev.digiid }} ({{ dev.sitename }})
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-4">
          <mat-label>Duration </mat-label>
          <mat-select [(ngModel)]="timeFilter" (selectionChange)="filters($event.value)">
            <mat-option *ngFor="let time of timeOptions" [value]="time">
              {{ time }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-1"></div>
        <div style="margin-top: 10px;padding-right: 5px;" class="col-md-1">
          <button class="header-tab alerts-tab" (click)="goToAlerts()">
            <span class="tab-text">ALERTS</span>
            <span class="tab-badge" *ngIf="totalAlerts > 0">{{ totalAlerts }}</span>
          </button>
          </div>
          <div style="margin-top: 10px;padding-left: 5px;" class="col-md-1">
          <button class="header-tab reports-tab" (click)="goToReports()">
            <span class="tab-text">REPORT</span>
          </button>
        </div>
      </div>
      <ngx-ui-loader [loaderId]="'analytics'"></ngx-ui-loader>

      <div style="padding-bottom: 10px;" class="kpi-row-4">
        <article class="card small efficiency-card">
          <div class="card-head">
            <div class="card-title">Generators Status</div>
            <mat-icon>insights</mat-icon>
          </div>
          <div class="card-body center">
            <div class="kpi-values small highlight-blue">
              Total Generators: <span style="padding-left: 8vh">{{ totalGenerators }}</span>
            </div>
            <div class="kpi-values small highlight-green">
              Online Generators: <span *ngIf="deviceStatus" style="padding-left: 8vh">{{ deviceStatus.online }}</span>
            </div>
            <div class="kpi-values small highlight-black">
              Offline Generators: <span  *ngIf="deviceStatus" style="padding-left: 8vh">{{ deviceStatus.offline }}</span>
            </div>
            
          </div>
        </article>

        <article class="card small running-card">
          <div class="card-head">
            <div class="card-title">Utilization Status</div>
            <mat-icon>schedule</mat-icon>
          </div>
          <div class="card-body center">
            <div *ngIf="fuelDataObject" class="kpi-value large highlight-blue">
              {{ utilizationStatus}}
            </div>
              
          </div>
        </article>

        <article class="card small running-card">
          <div class="card-head">
            <div class="card-title">Total KVAH Generated Per Ltr</div>
            <mat-icon aria-hidden="false" aria-label="energy">bolt</mat-icon>
          </div>
          <div class="card-body center">
            <div *ngIf="fuelDataObject"  class="kpi-value large highlight-blue">
              <!-- You can compute this value in the component; placeholder for now -->
              {{ fuelDataObject.kwhperliter }}
            </div>
            <div class="muted">KVAH/Ltr</div>
          </div>
        </article>

        <article class="card small running-card">
          <div class="card-head">
            <div class="card-title">Generator Fuel Price</div>
            <span>₹</span>
          </div>
          <div class="card-body center">
            <div *ngIf="generatorInfo" class="kpi-value large highlight-blue">
              ₹{{generatorInfo.fuelPrice }} /Ltr
            </div>
            <div *ngIf="generatorInfo" class="muted">{{generatorInfo.city}}</div>
          </div>
        </article>
      </div>

      <section class="cards-grid">
        <!-- Energy Generated Card -->
        <article class="card large energy-card">
          <div class="card-head">
            <div>
              <div class="card-title">Energy Generated</div>
            </div>
            <mat-icon aria-hidden="false" aria-label="energy">bolt</mat-icon>
          </div>

          <div class="card-body">
            <div class="kpi-row">
              <div class="kpi">
                <div class="kpi-label">Active (kWh)</div>
                <div style="color: rgba(19, 135, 19, 0.863);" class="kpi-value">{{ metrics.KWH | number:'1.0-2' }}</div>
              </div>
              <div class="kpi">
                <div class="kpi-label">Apparent (kVAh)</div>
                <div style="color: orange;" class="kpi-value">{{ metrics.KVAH | number:'1.0-2' }}</div>
              </div>
              <div class="kpi">
                <div class="kpi-label">Reactive (kVARh)</div>
                <div style="color: rgba(191, 19, 19, 0.808);" class="kpi-value">{{ metrics.KVARH | number:'1.0-2' }}</div>
              </div>
            </div>
          </div>
        </article>

        <!-- Fuel & Cost Card -->
        <article class="card medium fuel-card">
          <div class="card-head">
            <div class="card-title">Approx. Fuel & Cost Analysis</div>
            <mat-icon>local_gas_station</mat-icon>
          </div>

          <div *ngIf="fuelDataObject"  class="card-body compact">
            <div class="fuel-row">
              <div class="fuel-item">
                <div class="fuel-label">Fuel Rate / KVAH</div>
                <div class="fuel-value highlight-red">
                  {{ fuelDataObject.fuelPerKWh | currency:'INR':'symbol':'1.2-2' }}
                </div>
              </div>

              <div class="fuel-item">
                <div class="fuel-label">Total Fuel Used</div>
                <div class="fuel-value">
                  {{ fuelDataObject.fuelUsedLitres | number:'1.2-2' }} L
                </div>
              </div>
            </div>

            <div class="cost">
              <div class="cost-label">Total Cost</div>
              <div class="cost-value highlight-purple">
                {{ fuelDataObject.fuelCost | currency:'INR' }}
              </div>
            </div>
          </div>
        </article>
      </section>

      <div class="kpi-row-4">
        <article class="card small running-card">
          <div class="card-head">
            <div class="card-title">Total Running Hours</div>
            <mat-icon>schedule</mat-icon>
          </div>
          <div class="card-body center">
            <div class="kpi-value large highlight-blue">
              {{ metrics.runningHours | number:'1.0-2' }} h
            </div>
          </div>
        </article>

        <article class="card small fuel-rate-card">
          <div class="card-head">
            <div class="card-title">Fuel Refill</div>
            <mat-icon>local_gas_station</mat-icon>
          </div>
          <div class="card-body center">
            <div *ngIf="fuelDataObject" class="kpi-value large highlight-red">
              {{ fuelDataObject.refillCount }}
            </div>
            <div class="muted">Times</div>
          </div>
        </article>

        <article class="card small load-factor-card">
          <div class="card-head">
            <div class="card-title">Load Factor</div>
            <mat-icon>speed</mat-icon>
          </div>
          <div class="card-body center">
            <div class="kpi-value large highlight-orange">
              {{ metrics.loadFactor | number:'1.2-2' }}
            </div>
            <div class="muted">Better > 0.7</div>
          </div>
        </article>

        <article class="card small efficiency-card">
          <div class="card-head">
            <div class="card-title">Energy Efficiency</div>
            <mat-icon>insights</mat-icon>
          </div>
          <div class="card-body center">
            <div class="kpi-value large highlight-green">
              {{ metrics.energyEfficiency | percent:'1.0-0' }}
            </div>
          </div>
        </article>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="Live Data">
    <div *ngIf="isData" class="dg-monitoring-dashboard">
      <div class="header-section">
        <div class="header-left">
          <div *ngIf="generatorIds" class="device-section">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label class="device-label">Select Device</mat-label>
              <mat-select class="device-select" [(ngModel)]="selectedDevice" (selectionChange)="onDeviceSelect($event.value)">
                <mat-option *ngFor="let dev of generatorIds" [value]="dev">
                  {{ dev.digiid }} ({{ dev.sitename }})
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="header-center">
          <div class="last-data-label">LAST DATA RECEIVED</div>
          <div *ngIf="currentData" class="last-data-time">
            {{ currentData.Date }}
          </div>
        </div>

        <div class="header-tabs">
          <button class="header-tab alerts-tab" (click)="goToAlerts()">
            <span class="tab-text">ALERTS</span>
            <span class="tab-badge" *ngIf="totalAlerts > 0">{{ totalAlerts }}</span>
          </button>

          <button class="header-tab reports-tab" (click)="goToReports()">
            <span class="tab-text">REPORT</span>
          </button>
        </div>
      </div>

      <div *ngIf="currentData" class="dashboard-content">
        <div class="left-panel">
          <div class="fuel-level-card">
            <div class="card-header">
              <h3>RPM</h3>
            </div>
            <div class="rpm-gauge">
              <div class="rpm-circle-container">
                <svg class="rpm-progress-ring" width="220" height="220" viewBox="0 0 220 220">
                  <circle cx="110" cy="110" r="85" fill="none" stroke="rgba(51, 65, 85, 0.4)" stroke-width="8" stroke-linecap="round"></circle>
                  <circle cx="110" cy="110" r="85" fill="none" stroke="url(#rpmGradient)" stroke-width="8" stroke-linecap="round"
                          [attr.stroke-dasharray]="534"
                          [attr.stroke-dashoffset]="getRPMDashOffset()"
                          transform="rotate(-90 110 110)" class="rpm-progress-circle"></circle>
                  <defs>
                    <linearGradient id="rpmGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" style="stop-color:#22c55e;stop-opacity:1" />
                      <stop offset="40%" style="stop-color:#84cc16;stop-opacity:1" />
                      <stop offset="70%" style="stop-color:#f59e0b;stop-opacity:1" />
                      <stop offset="85%" style="stop-color:#f97316;stop-opacity:1" />
                      <stop offset="100%" style="stop-color:#ef4444;stop-opacity:1" />
                    </linearGradient>
                  </defs>
                </svg>

                <div class="rpm-value-container">
                  <span class="rpm-number">{{ getAny(currentData, ['RPM'], 0) }}</span>
                  <span class="rpm-unit">RPM</span>
                </div>
              </div>
            </div>
          </div>

          <div class="oil-temp-card">
            <div class="card-header">
              <h3>OIL TEMPERATURE</h3>
            </div>

            <div class="oil-temp-gauge">
              <svg class="oil-progress-ring" width="220" height="120" viewBox="0 0 220 120">
                <path d="M 30 110 A 80 80 0 0 1 190 110" fill="none" stroke="rgba(51,65,85,0.4)" stroke-width="12" stroke-linecap="round"></path>
                <path d="M 30 110 A 80 80 0 0 1 190 110" fill="none" stroke="url(#oilTempGradient)" stroke-width="12" stroke-linecap="round"
                      [attr.stroke-dasharray]="oilGaugeCircumference"
                      [attr.stroke-dashoffset]="getOilTempDashOffset()"
                      class="oil-progress-circle"></path>
                <defs>
                  <linearGradient id="oilTempGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" style="stop-color:#22c55e;stop-opacity:1" />
                    <stop offset="60%" style="stop-color:#f59e0b;stop-opacity:1" />
                    <stop offset="100%" style="stop-color:#ef4444;stop-opacity:1" />
                  </linearGradient>
                </defs>
              </svg>

              <div class="oil-value-container">
                <span class="oil-number">{{ getAny(currentData, ['Oil_Temp'], 0) | number:'1.0-0' }}</span>
                <span class="oil-unit">°C</span>
              </div>

              <div class="oil-tick-labels">
                <span>{{ oilTempMin }}</span>
                <span>{{ oilTempMax }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="center-panel">
          <div class="rpm-gauge-card">
            <h3>FUEL LEVEL</h3>
            
            <div class="fuel-gauge-container">
              <div class="fuel-cylinder">
                <div class="fuel-scale">
                  <span class="scale-mark">100</span>
                  <span class="scale-mark">75</span>
                  <span class="scale-mark">50</span>
                  <span class="scale-mark">25</span>
                  <span class="scale-mark">0</span>
                </div>
                <div class="fuel-tank">
                  <div class="fuel-fill"
                       [style.height.%]="getFuelGaugeHeight()"
                       [ngClass]="getFuelColorClass()">
                    <div class="fuel-percentage">{{ Math.round(getAny(currentData, ['Fuel_Level'], 0)) }}%</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="refuel-info">
              <span class="refuel-text">
                Level: {{ getAny(currentData, ['Fuel_Level'], 0) }}%
              </span>
              <span class="refuel-text" [class.warning]="shouldShowRefuelWarning()">
                Refuel at: {{ getAny(currentData, ['refuelAt'], 20) }}%
              </span>
            </div>
            
          </div>
        </div>

        <div class="right-panel">
          <div class="voltage-row-top">
            <div class="voltage-card">
              <div class="voltage-label">L1 VOLTAGE</div>
              <div class="voltage-value" [ngClass]="'status-' + getVoltageStatus(getAny(currentData, ['L1_Voltage'], 0), 'l1')">
                {{ getAny(currentData, ['L1_Voltage'], 0) | number:'1.2-2' }} <span class="unit">V</span>
              </div>
            </div>

            <div class="voltage-card">
              <div class="voltage-label">L2 VOLTAGE</div>
              <div class="voltage-value" [ngClass]="'status-' + getVoltageStatus(getAny(currentData, ['L2_Voltage'], 0), 'l2')">
                {{ getAny(currentData, ['L2_Voltage'], 0) | number:'1.2-2' }} <span class="unit">V</span>
              </div>
            </div>

            <div class="voltage-card">
              <div class="voltage-label">L3 VOLTAGE</div>
              <div class="voltage-value" [ngClass]="'status-' + getVoltageStatus(getAny(currentData, ['L3_Voltage'], 0), 'l3')">
                {{ getAny(currentData, ['L3_Voltage'], 0) | number:'1.2-2' }} <span class="unit">V</span>
              </div>
            </div>
          </div>

          <div class="voltage-row-bottom">
            <div class="voltage-card">
              <div class="voltage-label">L1L2 VOLTAGE</div>
              <div class="voltage-value" [ngClass]="'status-' + getVoltageStatus(getAny(currentData, ['L1L2_Voltage'], 0), 'l1l2')">
                {{ getAny(currentData, ['L1L2_Voltage'], 0) | number:'1.2-2' }} <span class="unit">V</span>
              </div>
            </div>

            <div class="voltage-card">
              <div class="voltage-label">L2L3 VOLTAGE</div>
              <div class="voltage-value" [ngClass]="'status-' + getVoltageStatus(getAny(currentData, ['L2L3_Voltage'], 0), 'l2l3')">
                {{ getAny(currentData, ['L2L3_Voltage'], 0) | number:'1.1-1' }} <span class="unit">V</span>
              </div>
            </div>

            <div class="voltage-card">
              <div class="voltage-label">L3L1 VOLTAGE</div>
              <div class="voltage-value" [ngClass]="'status-' + getVoltageStatus(getAny(currentData, ['L3L1_Voltage'], 0), 'l3l1')">
                {{ getAny(currentData, ['L3L1_Voltage'], 0) | number:'1.2-2' }} <span class="unit">V</span>
              </div>
            </div>
          </div>

          <div class="voltage-row-bottom">
            <div class="voltage-card">
              <div class="voltage-label">IUBALANCE</div>
              <div class="voltage-value">
                {{ getInbalance(currentData).imbalancePercent }} <span class="unit">%</span>
                <div class="unit">{{ getInbalance(currentData).status }}</div>
              </div>
            </div>

            <div class="voltage-card">
              <div class="voltage-label">VUNBALANCE</div>
              <div class="voltage-value">
                {{ getVunbalance(currentData).vunbalancePercent | number:'1.1-1' }} <span class="unit">%</span>
                <div class="unit">{{ getVunbalance(currentData).status }}</div>
              </div>
            </div>

            <div class="voltage-card">
              <div class="voltage-label">EFFICIENCY</div>
              <div class="voltage-value">
                {{ (getAny(currentData, ['Total_KW'], 0) / (getAny(currentData, ['Total_KVA'], 1) || 1)) | number:'1.2-2' }} <span class="unit">%</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom-section">
        <div class="current-row">
          <div class="current-card">
            <div class="current-label">L1 CURRENT</div>
            <div class="current-value" [ngClass]="'status-' + getCurrentStatus(getAny(currentData, ['L1_Current'], 0))">
              {{ getAny(currentData, ['L1_Current'], 0) }} <span class="unit">A</span>
            </div>
          </div>

          <div class="current-card">
            <div class="current-label">L2 CURRENT</div>
            <div class="current-value" [ngClass]="'status-' + getCurrentStatus(getAny(currentData, ['L2_Current'], 0))">
              {{ getAny(currentData, ['L2_Current'], 0) }} <span class="unit">A</span>
            </div>
          </div>

          <div class="current-card">
            <div class="current-label">L3 CURRENT</div>
            <div class="current-value" [ngClass]="'status-' + getCurrentStatus(getAny(currentData, ['L3_Current'], 0))">
              {{ getAny(currentData, ['L3_Current'], 0) }} <span class="unit">A</span>
            </div>
          </div>

          <div class="current-card">
            <div class="current-label">POWER FACTOR</div>
            <div class="current-value" [ngClass]="'status-' + getPowerFactorStatus()">
              {{ getAny(currentData, ['PF'], 1) | number:'1.2-2' }}
            </div>
          </div>

          <div class="current-card">
            <div class="current-label">KVAH</div>
            <div class="current-value">{{ getAny(currentData, ['KVAH'], 0) | number:'1.1-1' }}</div>
          </div>
        </div>

        <div class="power-row">
          <div class="power-card">
            <div class="power-label">TOTAL KW</div>
            <div class="power-value">{{ getAny(currentData, ['Total_KW'], 0) | number:'1.1-1' }}</div>
          </div>

          <div class="power-card">
            <div class="power-label">TOTAL KVA</div>
            <div class="power-value">{{ getAny(currentData, ['Total_KVA'], 0) | number:'1.1-1' }}</div>
          </div>

          <div class="power-card">
            <div class="power-label">TOTAL KVAR</div>
            <div class="power-value">{{ getAny(currentData, ['Total_KVAR'], 0) | number:'1.1-1' }}</div>
          </div>

          <div class="power-card">
            <div class="power-label">KWH</div>
            <div class="power-value">{{ getAny(currentData, ['KWH'], 0) | number:'1.1-1' }}</div>
          </div>

          <div class="power-card">
            <div class="power-label">KVARH</div>
            <div class="power-value">{{ getAny(currentData, ['KVARH'], 0) | number:'1.1-1' }}</div>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
